const importPackage = <T extends unknown>(nameWithVersion: string): Promise<T> =>
    new Promise<T>((resolve, reject) => {
        const url = `https://static.parastorage.com/unpkg/${nameWithVersion}`
        // @ts-expect-error
        __non_webpack_require__(
            [url],
            (response: T) => {
                resolve(response)
            },
            (err: Error) => {
                reject(err)
            }
        )
    })

export {importPackage}
